// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// RxJS
import { combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, MenuConfigService, PageConfigService, SubheaderService } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { LayoutConfig } from '../../../core/_config/layout.config';
import { MenuConfig } from '../../../core/_config/menu.config';
import { PageConfig } from '../../../core/_config/page.config';
// User permissions
import { NgxPermissionsService } from 'ngx-permissions';
import { currentUser, currentUserPermissions, Permission } from '../../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { filter, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { ModuleService } from '../../../core/plant-configuration/_services/module.service';
import { CompanyService } from '../../../core/auth/_services/company.service';
import { Router } from '@angular/router';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'kt-base',
	templateUrl: './base.component.html',
	styleUrls: ['./base.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BaseComponent implements OnInit, OnDestroy {
	// Public variables
	selfLayout: string;
	asideDisplay: boolean;
	asideSecondary: boolean;
	subheaderDisplay: boolean;
	fluid: boolean;

	// Private properties
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	private currentUserPermissions$: Observable<Permission[]>;
	user: any;
	moduleList$: Subject<any> = new Subject<any>();
	private readonly visualMenuIconByRoute: {[key: string]: string} = {
		'/production/realtime-machines': './assets/media/icons/svg/Devices/Server.svg',
		'/production/dashboard/machine/list': './assets/media/icons/svg/Devices/Server.svg',
		'/production/quality/list': './assets/media/icons/svg/General/Shield-check.svg',
		'/production/history/quality': './assets/media/icons/svg/General/Shield-check.svg',
		'/production/manual/data/list': './assets/media/icons/svg/General/Clipboard.svg',
		'/plant-configuration/quality-type': './assets/media/icons/svg/General/Trash.svg',
		'/controlir4-config/modules': './assets/media/icons/svg/Layout/Layout-4-blocks.svg'
	};


	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 * @param menuConfigService: MenuConfifService
	 * @param pageConfigService: PageConfigService
	 * @param htmlClassService: HtmlClassService
	 * @param store
	 * @param permissionsService
	 */
	constructor(
		private layoutConfigService: LayoutConfigService,
		private menuConfigService: MenuConfigService,
		private pageConfigService: PageConfigService,
		private htmlClassService: HtmlClassService,
		private store: Store<AppState>,
		private permissionsService: NgxPermissionsService,
		private moduleService: ModuleService,
		private companyService: CompanyService,
		private router: Router,
		private subheaderService: SubheaderService,
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer
		) {
		this.loadRolesWithPermissions();
		iconRegistry.addSvgIcon(
			'Box3',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/Shopping/Box3.svg'));
		iconRegistry.addSvgIcon(
			'Server',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/Devices/Server.svg'));
		iconRegistry.addSvgIcon(
			'Hard-drive',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/Devices/Hard-drive.svg'));
		iconRegistry.addSvgIcon(
			'Clipboard',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/General/Clipboard.svg'));
		iconRegistry.addSvgIcon(
			'Chart-bar2',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/Shopping/Chart-bar2.svg'));
		iconRegistry.addSvgIcon(
			'Chart-line2',
			sanitizer.bypassSecurityTrustResourceUrl('assets/media/icons/svg/Shopping/Chart-line2.svg'));

		// register configs by demos
		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);

		this.pageConfigService.loadConfigs(new PageConfig().configs);

		const user$ = this.store.pipe(select(currentUser));
		//console.log("base user subscribe");
		this.unsubscribe.push(
			user$.pipe(
				filter((user)=>user!=undefined),
				tap(user=>{this.user = user; console.log("user found")}),
				switchMap(()=>this.companyService.companyLoaded$),
				switchMap(()=>this.moduleService.getAll()),
				map((moduleList)=>this.moduleService.mapToModuleList(moduleList))
			).subscribe((moduleList)=>{
				//console.log("module list configuration loading")
				var menuConfigList = new MenuConfig().configs;
				if(moduleList==undefined || moduleList.length==0){
					this.menuConfigService.loadConfigs(Object.assign(menuConfigList,
						{header: {items : []}}));
					return;
				};
				moduleList = this.applyVisualMenuIcons(moduleList).map(item=>{
					let icon_path = item.icon_path;
					if(icon_path != undefined){
						icon_path = icon_path.split('/');
						icon_path = icon_path[icon_path.length-1];
						icon_path = icon_path.split('.')[0];
					}
					return Object.assign(item, {icon: icon_path})
		})
				// console.log("user found");

				// console.log("menu raw list: ");console.dir(menuConfigList);
				// const menu = menuConfigList.header.items;
				// moduleList.forEach(module_=>{
				// 	const item = menu.find(item=>item.title.toLowerCase() == module_.title.toLowerCase());
				// 	if(item==undefined){
				// 		console.log(`no se pudo encontrar el modulo ${module_.title}`);
				// 	}
				// 	module_.groups = item.groups;
				// 	if(module_.submenu){
				// 		module_.submenu.forEach(subModule=>{
				// 			// console.log('item');console.dir(item);
				// 			// console.log('module');console.dir(module_);
				// 			const subItem = item.submenu.find(subItem=>subItem.title.toLowerCase() == subModule.title.toLowerCase());
				// 			if(subItem==undefined){
				// 				console.log(`no se pudo encontrar el submodulo ${subModule.title}`);
				// 			}
				// 			subModule.groups = subItem.groups;
				// 			if(subModule.submenu){
				// 				subModule.submenu.forEach(subSubModule=>{
				// 					const subSubItem = item.submenu.find(subSubItem=>subSubItem.title.toLowerCase() == subSubModule.title.toLowerCase());
				// 					if(subSubItem==undefined){
				// 						console.log('item');console.dir(item);
				// 						console.log('module');console.dir(module_);
				// 						console.log(`no se pudo encontrar el subsubmodulo ${subSubModule.title}`);
				// 					}
				// 					subSubModule.groups = subSubItem.groups;
				// 				})
				// 			}
				// 		});
				// 	}
				// });

				//console.log('module list base component: ');console.dir(moduleList);
				// console.log(`filtering by user group id: ${this.user.group_id}`);
				// console.dir(this.filterMenu(this.user.group_id, moduleList));
				// this.menuConfigService.loadConfigs(Object.assign(menuConfigList,
				// 	{header: {items : this.filterMenu(this.user.group_id, menuConfigList.header.items)}}));
				this.menuConfigService.loadConfigs(Object.assign(menuConfigList,
					{header: {items : this.filterMenu(this.user.group_id, moduleList)}}));


				this.moduleList$.next(moduleList);
			})
		)

		this.unsubscribe.push(
			combineLatest([this.moduleList$, this.router.events]).subscribe(([moduleList, data])=>{
				/*console.log("HA CAMBIADO EL MODULO O LA RUTA")
				console.dir({moduleList, data});*/
				function isItemSelected(item, url){
					return item.submenu==undefined && item.page == url;
				}
				function getSelectedItem(menu:any, url: string){
					// console.log(`searching url: ${url} on menu: `);
					// console.dir(menu);
					if(menu.length>0){
						// console.log("menu es lista")
						for(let submenu of menu){
							// console.log("recursividad activada")
							const selectedItem = getSelectedItem(submenu, url);
							if(selectedItem) return selectedItem;
						}
					}else if (menu.submenu == undefined){
						if(isItemSelected(menu, url)){
							// console.log(`se considera como seleccionado el item: `);console.dir(menu);
							return menu;
						}
					}else if(menu.submenu !=undefined){
						// console.log("submenu existe")
						for(let submenu of menu.submenu){
							const selectedItem = getSelectedItem(submenu, url);
							if(selectedItem) return [menu].concat(selectedItem);
						}
					}else{
						// console.log("algo paso :C")
					}
				}
				//console.log("selected item: ");
				const menuPath = getSelectedItem(moduleList, data['urlAfterRedirects']);
				//console.dir(menuPath);
				if(menuPath != undefined && menuPath.length > 0){
					this.subheaderService.setTitle(menuPath[menuPath.length-1].name);
					this.subheaderService.setBreadcrumbs(
						menuPath.map(item=>{
							return {
								title: item.name,
								page: item.page
							}
						})
					);
				}
					// [
					// { title: 'Planta', page: `/production/plant/1` },
					// { title: 'part 2', page: `/ecommerce/products` },
					// { title: 'part 3', page: `/ecommerce/products/edit`, queryParams: { id: 1 } }
				// ]);
			})
		)

		// setup element classes
		this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(layoutConfig => {
			// reset body class based on global and page level layout config, refer to html-class.service.ts
			document.body.className = '';
			this.htmlClassService.setConfig(layoutConfig);
		});
		this.unsubscribe.push(subscr);
	}

	private applyVisualMenuIcons(items: any[]): any[] {
		return (items || []).map(item => {
			const submenu = Array.isArray(item.submenu)
				? this.applyVisualMenuIcons(item.submenu)
				: item.submenu;
			const visualIconPath = this.getVisualMenuIcon(item);

			return Object.assign({}, item, {
				submenu: submenu,
				icon_path: visualIconPath || item.icon_path
			});
		});
	}

	private getVisualMenuIcon(item: any): string {
		const page = String(item && item.page || '')
			.split(/[?#]/)[0]
			.replace(/\/+$/, '') || '/';
		const route = Object.keys(this.visualMenuIconByRoute)
			.find(path => page === path || page.indexOf(path + '/') === 0);

		return route ? this.visualMenuIconByRoute[route] : null;
	}

	filterMenu(groupId, menuList){
		var filteredMenu = [];
		// console.log(`filtering menu by group ${groupId}`)
		menuList.forEach(menuItem => {
			var submenu = menuItem.submenu;
			// console.log("menu Item:");console.dir(menuItem);
			if(submenu){
				submenu = this.filterMenu(groupId, submenu);
			}
			if(menuItem.groups == undefined || menuItem.groups.includes(groupId)){
				filteredMenu.push(Object.assign(menuItem, {submenu: submenu}))
			}
		});
		return filteredMenu;
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		const config = this.layoutConfigService.getConfig();
		this.selfLayout = objectPath.get(config, 'self.layout');
		this.asideDisplay = objectPath.get(config, 'aside.self.display');
		this.asideSecondary = objectPath.get(config, 'aside-secondary.self.display');
		this.subheaderDisplay = objectPath.get(config, 'subheader.display');
		//console.log(`sub header display: ${this.subheaderDisplay}`);
		this.fluid = objectPath.get(config, 'content.width') === 'fluid';

		// let the layout type change
		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
			setTimeout(() => {
				this.selfLayout = objectPath.get(cfg, 'self.layout');
			});
		});
		this.unsubscribe.push(subscr);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// console.log("destroy base");
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}

	/**
	 * NGX Permissions, init roles
	 */
	loadRolesWithPermissions() {
		this.currentUserPermissions$ = this.store.pipe(select(currentUserPermissions));
		const subscr = this.currentUserPermissions$.subscribe(res => {
			if (!res || res.length === 0) {
				return;
			}

			this.permissionsService.flushPermissions();
			res.forEach((pm: Permission) => this.permissionsService.addPermission(pm.name));
		});
		this.unsubscribe.push(subscr);
	}
}
